import { Stack } from '@understory-io/leaf/stack';
import { Text } from '@understory-io/leaf/text';
import { css } from '@understory-io/leaf/css';
import { FormattedMessage } from 'react-intl';

/**
 * Shown when the feed comes back with no events.
 *
 * Page-local rather than shared, because neither existing empty state fits:
 * `~/ui/availability-empty-state` is a waitlist signup for one experience's
 * booking widget (this page spans many, so there is nothing to sign up for),
 * and home's `EmptyState` is worded for experiences, not events. The layout
 * deliberately mirrors home's so the two pages feel the same.
 *
 * The filtered variant — "nothing matches your filters", with a reset — lands
 * with the filter bar itself; until then the page has no controls to reset.
 */
export function UpcomingEventsEmptyState() {
  return (
    <Stack as="section" gap="small" align="center" className={panelStyles}>
      <Text as="h2" style="subheadline-large">
        <FormattedMessage
          defaultMessage="No upcoming events"
          description="Heading on the upcoming events page when there are no scheduled events to list"
        />
      </Text>
      <Text as="p" style="body-large-regular" color="secondary">
        <FormattedMessage
          defaultMessage="There are no events scheduled right now. Please check back soon!"
          description="Body copy on the upcoming events page when there are no scheduled events to list"
        />
      </Text>
    </Stack>
  );
}

const panelStyles = css({
  textAlign: 'center',
  paddingY: { base: '3xlarge', tablet: '5xlarge' },
  // No Leaf token for a comfortable reading-width text column; use the Panda
  // escape hatch so the heading + body wrap before the full PageCard width.
  maxWidth: '[600px]',
  marginX: 'auto',
});
